import { apiFetch } from './client';

export const retellApi = {
  voices: () => apiFetch('/api/voices'),
  agents: () => apiFetch('/api/retell/agents'),
  phoneNumbers: () => apiFetch('/api/retell/phone-numbers'),
};
